<template>
    <ul id="ScrollNum" ref="ScrollNum" class="c-scroll-num">
        <template v-for="(pos, index) of positionList" >
            <single v-if="typeof pos==='number'" :key="index" :i="pos" :delay="index + delay" as="li" class="num" :list="cellItemList" />
            <div v-else :key="`other-${index}`" class="scroll-num">{{pos}}</div>
        </template>
    </ul>
</template>

<script>
import Single from './single';

/**
 * 老虎机效果
 */
export default {
    name: 'ScrollNum',
    components: { Single },
    props: {
        /**
         * 每个号码间隔动画时间
         */
        delay: {
            type: Number,
            default: 0.1
        },
        /**
         * 总量
         */
        totalNumber: {
            type: [String, Number]
        },
        cellItemList: {
            type: Array,
            default: () => {
                return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
            }
        }
    },
    computed: {
        /**
         * 位置
         */
        positionList() {
            let list = '';
            if (typeof this.totalNumber === 'number') {
                list = this.totalNumber.toString().split('');
            } else {
                list = this.totalNumber.split('');
            }
            return list.map((it) => {
                if (isNaN(it)) {
                    return it;
                }
                return this.cellItemList.findIndex((item) => +it === +item);
            });
        }
    }
};
</script>
<style lang="scss">
.c-scroll-num {
    display: flex;
    justify-content: center;
    align-items: center;
    --number-width: 16px;
    --number-height: 32px;
    --number-color: $text-primary;
    --number-font-size: 24px;

    .scroll-num {
        font-weight: 600;
        width: var(--number-width);
        height: var(--number-height);
        color: var(--number-color, #333);
        font-size: 24px;
        line-height: var(--number-height);
        text-align: center;
        overflow: hidden;
    }

    .animate {
        animation: scroll-num-move 0.2s linear infinite, bounce-in-down 0.2s calc(var(--delay) * 0.2s) forwards;
    }

    .border-animate {
        animation: enhance-bounce-in-down 0.2s calc(var(--delay) * 0.2s) forwards;
    }

    ul {
        padding: 0;
        margin: 0;
        list-style: none;
        transform: translateY(calc(var(--i) * var(--number-height) * -1));
    }

    @keyframes scroll-num-move {
        from {
            transform: translateY(-90%);
            filter: url(#blur);
        }
        to {
            transform: translateY(1%);
            filter: url(#blur);
        }
    }

    @keyframes bounce-in-down {
        from {
            transform: translateY(calc(var(--i) * var(--number-height) * -1 - 7%));
            filter: none;
        }
        25% {
            transform: translateY(calc(var(--i) * var(--number-height) * -1 + 3%));
        }
        50% {
            transform: translateY(calc(var(--i) * var(--number-height) * -1 - 1%));
        }
        70% {
            transform: translateY(calc(var(--i) * var(--number-height) * -1 + 0.2%));
        }
        85% {
            transform: translateY(calc(var(--i) * var(--number-height) * -1 - 0.2%));
        }
        to {
            transform: translateY(calc(var(--i) * var(--number-height) * -1));
        }
    }

    @keyframes enhance-bounce-in-down {
        25% {
            transform: translateY(8%);
        }
        50% {
            transform: translateY(-4%);
        }
        70% {
            transform: translateY(2%);
        }
        85% {
            transform: translateY(-1%);
        }
        to {
            transform: translateY(0);
        }
    }
}
</style>
